import React, { useState } from 'react';
import { Payments } from '@share/common-types';
import { SearchTable } from '../common';
import { MyPaymentListColumnMenu } from '../../../constants/columns/paymentList';

interface CreditLinePaymentProps {
  paymentList: Payments[];
  paymentListLoading: boolean;
}

const CompanyCreditLinePaymentsList: React.FC<CreditLinePaymentProps> = React.memo(
  ({ paymentList, paymentListLoading }) => {
    const [pagination, setPagination] = useState({
      current: 1,
      pageSize: 10,
    });
    const [filters, setFilters] = useState({});
    const GetAllCreditLineColumns = (): any[] => {
      return MyPaymentListColumnMenu.map((c) => {
        const column = { ...c };
        return column;
      });
    };

    const handleOnTableChange = (pagination: any, sorter: any, filter: any) => {};
    const handleOnFiltersChange = (updatedFilters: any) => {
      setFilters(updatedFilters);
    };
    const handleOnRowClick = (row: any) => {
      // setRecord(row);
      // setShowMarkAsDetailModal(true);
    };
    const handleOnResetFilters = () => {
      setFilters({});
      // fetchFilteredData(pagination.current, pagination.pageSize, {}, {});
    };

    const handleApplyFilters = (filters: any) => {
      // fetchFilteredData(pagination.current, pagination.pageSize, filters, paidDate);
    };
    const handleOnRefresh = () => {};
    const columns = GetAllCreditLineColumns();
    const dataSource = paymentList;
    const totalOrderCount = dataSource?.length;
    return (
      <>
        <SearchTable
          key={'active'}
          title={''}
          loading={paymentListLoading}
          // loading={loading}
          allColumns={[...columns]}
          dataSource={dataSource}
          pagination={pagination}
          filters={filters}
          totalOrderCount={totalOrderCount}
          rowKey={(row: any) => {
            return row.id ? `${row.id}` : `${row}`;
          }}
          isFilterApplied={!!Object.values(filters).some((filter) => filter.value !== null)}
          onFiltersChange={handleOnFiltersChange}
          onTableChange={handleOnTableChange}
          onRowClick={handleOnRowClick}
          onResetFilters={handleOnResetFilters}
          onApplyFilters={handleApplyFilters}
          onRefresh={handleOnRefresh}
          hideRefresh={true}
        ></SearchTable>
      </>
    );
  },
);

export default CompanyCreditLinePaymentsList;
